import React from "react";
import { useTranslation } from "react-i18next";

import ApplicationLayout from "src/layouts/Application";
import { Button } from "src/components-v2";

import ilus404 from "src/assets/images/common/ilus-404.png";
import history from "src/helpers/browser-history";
import publicRoutes from "src/routes/public-routes";
import privateRoutes from "src/routes/private-routes";
import { isAuthenticated } from "src/helpers/auth";
import { MAIL_TO_URL } from "src/consts/links";

function PageNotFound() {
  const { t } = useTranslation("not-found");

  function handleBack() {
    if (isAuthenticated()) {
      history.push(privateRoutes.home.path);
    } else {
      history.push(publicRoutes.login.path);
    }
  }

  return (
    <ApplicationLayout title="404" topBarTitle="" noSidebar={!isAuthenticated()} data-qaid="qa-not-found-page">
      <div className="u-pt-6 u-text-center">
        <h1 data-qaid="qa-not-found-title">{t("head")}</h1>

        <img src={ilus404} alt="404" height="280" className="u-mb-5" data-qaid="qa-not-found-illustration" />

        <p>{t("info")}</p>

        <Button onClick={handleBack} data-qaid="qa-not-found-button-redirect">
          {t(`back-${isAuthenticated() ? "home" : "login"}`)}
        </Button>

        <p className="u-mt-10">
          {t("contact-text")}{" "}
          <a href={MAIL_TO_URL} data-qaid="qa-not-found-link-mail">
            support@flip.id
          </a>{" "}
          {t("contact-text-next")}
        </p>
      </div>
    </ApplicationLayout>
  );
}

export default PageNotFound;
